import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-o-que-fazemos',
  templateUrl: './o-que-fazemos.component.html',
  styleUrls: ['./o-que-fazemos.component.css']
})
export class OQueFazemosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
